import { getSentimentSettings } from '../components/sentiment/SentimentHelpers';
export const SET_IS_LOADING = 'SENTIMENT/SET_IS_LOADING';
export const SET_SELECTED_HEADING_ID = 'SENTIMENT/SET_SELECTED_HEADING_ID';
export const SET_SENTIMENT_DRAWER_OPEN = 'TOPIC/SET_SENTIMENT_DRAWER_OPEN ';
export const SET_SENTIMENT = 'TOPIC/SET_SENTIMENT ';
export const SET_HIGHLIGHTS_DATA = 'TOPIC/SET_HIGHLIGHTS_DATA';
export const SET_SEARCH_TERM = 'SENTIMENT/SET_SEARCH_TERM';
export const SET_DOCUMENT_SELECTED_TAB = 'SENTIMENT/SET_DOCUMENT_SELECTED_TAB';
export const SET_COMPUTEXT_TAB_DATA = 'SENTIMENT/SET_COMPUTEXT_TAB_DATA';
export const SET_SENTIMENT_DATA = 'SENTIMENT/SET_SENTIMENT_DATA';
export const SET_COMPUTEXT_TAB_PIE_DATA = 'SENTIMENT/SET_COMPUTEXT_TAB_PIE_DATA';

export const setIsLoading = isLoading => ({
  type: SET_IS_LOADING,
  isLoading,
});

export const setSelectedHeadingId = selectedHeadingId => ({
  type: SET_SELECTED_HEADING_ID,
  selectedHeadingId,
});

export const setSentimentDrawerOpen = isSentimentDrawerOpen => ({
  type: SET_SENTIMENT_DRAWER_OPEN,
  isSentimentDrawerOpen,
});

export const setSentimentFilters = sentiment => ({
  type: SET_SENTIMENT,
  sentiment,
});

export const setHighlightsData = highlightsData => ({
  type: SET_HIGHLIGHTS_DATA,
  highlightsData,
});

export const setSearchTerm = searchTerm => ({
  type: SET_SEARCH_TERM,
  searchTerm,
});

export const setDocumentSelectedTab = documentSelectedTab => ({
  type: SET_DOCUMENT_SELECTED_TAB,
  documentSelectedTab,
});

export const setComputextTabData = computextTabData => ({
  type: SET_COMPUTEXT_TAB_DATA,
  computextTabData,
});

export const setSentimentData = sentimentData => ({
  type: SET_SENTIMENT_DATA,
  sentimentData,
});

export const setComputextTabPieData = computextTabPieData => ({
  type: SET_COMPUTEXT_TAB_PIE_DATA,
  computextTabPieData,
});

const getDefaultState = () => {
  return {
    isLoading: false,
    selectedHeadingId: null,
    documentSelectedTab: null,
    isSentimentDrawerOpen: false,
    sentiment: getSentimentSettings('visible'),
    highlightsData: null,
    searchTerm: null,
    computextTabData: null,
    sentimentData: null,
    computextTabPieData: null,
  };
};

export default function reducer(
  state = {
    ...getDefaultState(),
  },
  action
) {
  switch (action.type) {
    case SET_IS_LOADING:
      return { ...state, isLoading: action.isLoading };
    case SET_SELECTED_HEADING_ID:
      return { ...state, selectedHeadingId: action.selectedHeadingId };
    case SET_SENTIMENT_DRAWER_OPEN:
      return { ...state, isSentimentDrawerOpen: action.isSentimentDrawerOpen };
    case SET_SENTIMENT:
      return { ...state, sentiment: action.sentiment };
    case SET_HIGHLIGHTS_DATA:
      return { ...state, highlightsData: action.highlightsData };
    case SET_SEARCH_TERM:
      return { ...state, searchTerm: action.searchTerm };
    case SET_DOCUMENT_SELECTED_TAB:
      return { ...state, documentSelectedTab: action.documentSelectedTab };
    case SET_COMPUTEXT_TAB_DATA:
      return { ...state, computextTabData: action.computextTabData };
    case SET_SENTIMENT_DATA:
      return { ...state, sentimentData: action.sentimentData };
    case SET_COMPUTEXT_TAB_PIE_DATA:
      return { ...state, computextTabPieData: action.computextTabPieData };

    default:
      break;
  }
  return state;
}
